import React from 'react';

const isModifiedEvent = (event) =>
  event.metaKey || event.altKey || event.ctrlKey || event.shiftKey;

function RouteLink({ to, children, onClick, ...rest }) {
  return (
    <a
      href={to}
      onClick={(event) => {
        if (onClick) onClick(event);
        if (event.defaultPrevented) return;
        if (event.button !== 0 || isModifiedEvent(event)) return;
        if (!to || typeof to !== 'string') return;
        if (to.startsWith('http') || to.startsWith('mailto:') || to.startsWith('#')) return;
        event.preventDefault();
        window.history.pushState({}, '', to);
        window.dispatchEvent(new PopStateEvent('popstate'));
      }}
      {...rest}
    >
      {children}
    </a>
  );
}

export default RouteLink;
